import { render, staticRenderFns } from "./OnHoldUpdate.vue?vue&type=template&id=4a4fa116&scoped=true"
import script from "./OnHoldUpdate.vue?vue&type=script&lang=js"
export * from "./OnHoldUpdate.vue?vue&type=script&lang=js"
import style0 from "./OnHoldUpdate.vue?vue&type=style&index=0&id=4a4fa116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4fa116",
  null
  
)

export default component.exports